export default "__VITE_ASSET__77oaIsyP__"